import MiniSearch, { SearchResult } from 'minisearch';

let miniSearch: MiniSearch;
let fetchPromise: Promise<void> | null = null;

export const initSearch = (
    indexUrl: string,
    primaryFields: string[],
    secondaryFields: string[],
    storeFields: string[],
    combineWith: 'AND' | 'OR' = 'AND',
    fuzzy = 0.5,
    prefix = true
): Promise<void> => {
    miniSearch = new MiniSearch({
        fields: [...primaryFields, ...secondaryFields],
        idField: 'url',
        storeFields,
        searchOptions: {
            fuzzy,
            prefix,
            combineWith,
            boost: primaryFields.reduce(
                (boost, primaryfield, currentIndex): { [key: string]: number } => ({
                    ...boost,
                    [primaryfield]: currentIndex
                }),
                {}
            )
        }
    });

    fetchPromise = fetch(indexUrl)
        .then((response: Response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.blob();
        })
        .then((response: Blob) => response.text())
        .then((text: string): void => {
            miniSearch.addAll(JSON.parse(text));
        })
        .catch((error) => {
            console.error('Error fetching search index:', error);
            throw error;
        });

    return fetchPromise;
};

export const executeSearch = (query: string): SearchResult[] => miniSearch.search(query);

export const __testing = {
    getFetchPromise: () => fetchPromise
};
